/* eslint no-param-reassign: "error" */

import Vuex from "vuex";
import Vue from "vue";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../../tailwind.config";
import coatingCalculator from "../QuantityCalculator/coatingCalculatorStore";
import cart from "../SiteCart/store";
import favourites from "../SiteFavourites/store";
import router from "../../js/router";

const tailwind = resolveConfig(tailwindConfig);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { cart, coatingCalculator, favourites },
  state: {
    ui: {
      siteColors: tailwind.theme.colors,
      siteTheme: null,
      paintTheme: null,
      openedSiteMenu: null,
      siteMenuFlyoutIsOpen: false,
      siteCartIsOpen: false,
      siteFavouritesIsOpen: false,
      coatingCalculatorIsOpen: false,
      paintCalculatorIsOpen: false,
      siteMaskIsVisible: false,
      colourOverlayIsOpen: false,
      selectorIsOpen: false,
    },
    colourStory: "",
    quiz: {
      quizTheme: null,
      currentQuestion: 1,
      canProceed: false,
      validEmail: false,
      result: null,
      showForm: true,
      questions: {
        one: {},
        two: {},
        three: {},
        four: {},
        five: {},
        six: {},
        seven: {},
        eight: {},
        nine: {},
        ten: {},
        eleven: {},
        twelve: {},
        thirteen: {},
        fourteen: {},
        fourteenB: {},
        fifteen: {},
        fifteenB: {},
        sixteen: {},
        seventeen: {},
      },
      details: {
        name: "",
        email: "",
        colour: "",
        image: "",
        marketing: false,
      },
    },
  },
  actions: {
    goNext({ commit }, { next }) {
      router.push({ name: next });
      commit("setQuestion", next);
    },

    goPrev({ commit }, { prev }) {
      router.push({ name: prev });
      commit("setQuestion", prev);
    },
  },
  mutations: {
    setSiteTheme(state, payload) {
      state.ui.siteTheme = {
        "--paint": payload[0],
        "--theme": payload[1],
      };
    },
    setPaintTheme(state, payload) {
      state.ui.paintTheme = {
        "--paint": payload[0],
        "--theme": payload[1],
      };
    },
    toggleSiteMenu(state, key) {
      if (state.ui.openedSiteMenu === key) {
        state.ui.openedSiteMenu = null;
        state.ui.siteTheme = state.ui.paintTheme ? state.ui.paintTheme : null;
      } else {
        state.ui.openedSiteMenu = key;
        state.ui.siteTheme = {
          "--paint": tailwind.theme.colors.cream,
          "--theme": tailwind.theme.colors.black,
        };
      }
    },
    closeSiteMenu(state) {
      state.ui.openedSiteMenu = null;
      state.ui.siteTheme = state.ui.paintTheme ? state.ui.paintTheme : null;
    },
    toggleSiteMenuFlyout(state) {
      if (state.ui.siteMenuFlyoutIsOpen) {
        state.ui.siteMenuFlyoutIsOpen = false;
        state.ui.siteTheme = state.ui.paintTheme ? state.ui.paintTheme : null;
      } else {
        state.ui.siteMenuFlyoutIsOpen = true;
        state.ui.siteTheme = {
          "--paint": tailwind.theme.colors.cream,
          "--theme": tailwind.theme.colors.black,
        };
      }
    },
    closeSiteMenuFlyout(state) {
      state.ui.siteMenuFlyoutIsOpen = false;
      state.ui.siteTheme = state.ui.paintTheme ? state.ui.paintTheme : null;
    },
    openSiteCart(state) {
      state.ui.siteMenuFlyoutIsOpen = false;
      state.ui.siteCartIsOpen = true;
      state.ui.siteMaskIsVisible = true;
    },
    closeSiteCart(state) {
      state.ui.siteCartIsOpen = false;
      state.ui.siteMaskIsVisible = false;
    },
    openSiteFavourites(state) {
      state.ui.siteMenuFlyoutIsOpen = false;
      state.ui.siteFavouritesIsOpen = true;
      state.ui.siteMaskIsVisible = true;
    },
    closeSiteFavourites(state) {
      state.ui.siteFavouritesIsOpen = false;
      state.ui.siteMaskIsVisible = false;
    },
    openCoatingCalculator(state) {
      state.ui.coatingCalculatorIsOpen = true;
      state.ui.siteMaskIsVisible = true;
    },
    closeCoatingCalculator(state) {
      state.ui.coatingCalculatorIsOpen = false;
      state.ui.siteMaskIsVisible = false;
    },
    openPaintCalculator(state) {
      state.ui.siteMenuFlyoutIsOpen = false;
      state.ui.paintCalculatorIsOpen = true;
      state.ui.siteMaskIsVisible = true;
    },
    closePaintCalculator(state) {
      state.ui.paintCalculatorIsOpen = false;
      state.ui.siteMaskIsVisible = false;
    },
    toggleColourOverlay(state, payload) {
      state.ui.colourOverlayIsOpen = payload.value;
      state.colourStory = payload.story;
    },
    toggleSelector(state, payload) {
      state.ui.selectorIsOpen = payload;
    },
    setQuizTheme(state, payload) {
      state.quiz.quizTheme = {
        "--quiz-paint": payload[0],
        "--quiz-theme": payload[1],
      };
    },
    setQuestion(state, question) {
      state.quiz.currentQuestion = question;
    },
    setValidEmail(state, payload) {
      state.quiz.validEmail = payload.validEmail;
    },
    setCanProceed(state, payload) {
      state.quiz.canProceed = payload.canProceed;
    },
    setResult(state, result) {
      state.quiz.result = result;
    },
    setShowForm(state, result) {
      state.quiz.showForm = result;
    },
    setQuestionOne(state, payload) {
      state.quiz.questions.one = payload;
    },
    setQuestionTwo(state, payload) {
      state.quiz.questions.two = payload;
    },
    setQuestionThree(state, payload) {
      state.quiz.questions.three = payload;
    },
    setQuestionFour(state, payload) {
      state.quiz.questions.four = payload;
    },
    setQuestionFive(state, payload) {
      state.quiz.questions.five = payload;
    },
    setQuestionSix(state, payload) {
      state.quiz.questions.six = payload;
    },
    setQuestionSeven(state, payload) {
      state.quiz.questions.seven = payload;
    },
    setQuestionEight(state, payload) {
      state.quiz.questions.eight = payload;
    },
    setQuestionNine(state, payload) {
      state.quiz.questions.nine = payload;
    },
    setQuestionTen(state, payload) {
      state.quiz.questions.ten = payload;
    },
    setQuestionEleven(state, payload) {
      state.quiz.questions.eleven = payload;
    },
    setQuestionTwelve(state, payload) {
      state.quiz.questions.twelve = payload;
    },
    setQuestionThirteen(state, payload) {
      state.quiz.questions.thirteen = payload;
    },
    setQuestionFourteen(state, payload) {
      state.quiz.questions.fourteen = payload;
    },
    setQuestionFourteenB(state, payload) {
      state.quiz.questions.fourteenB = payload;
    },
    setQuestionFifteen(state, payload) {
      state.quiz.questions.fifteen = payload;
    },
    setQuestionFifteenB(state, payload) {
      state.quiz.questions.fifteenB = payload;
    },
    setQuestionSixteen(state, payload) {
      state.quiz.questions.sixteen = payload;
    },
    setQuestionSeventeen(state, payload) {
      state.quiz.questions.seventeen = payload;
    },
    setEmail(state, payload) {
      state.quiz.details.email = payload;
    },
    setMarketing(state, payload) {
      state.quiz.details.marketing = payload;
    },
    setName(state, payload) {
      state.quiz.details.name = payload;
    },
    setColour(state, payload) {
      state.quiz.details.colour = payload;
    },
    setImage(state, payload) {
      state.quiz.details.image = payload;
    },
  },
});
